// Google tag (gtag.js) 
// <script async src="https://www.googletagmanager.com/gtag/js?id=AW-11107373663"></script>
  var gtagScript = document.createElement('script');
  gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11107373663';
  gtagScript.async = true; // 将 async 属性设置为 true。
  document.head.appendChild(gtagScript);
  
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag('js', new Date());

  gtag('config', 'AW-11107373663');